import React, {useCallback} from 'react';

import navigateToURL from 'lib/navigateToURL';
import {ChatSettingsTab} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {chatSettingsModalUrl} from 'llm/routes/UrlUtils';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import SidebarRow from './SidebarRow';

export default function SetUpAnAgentRow(): JSX.Element {
  const handleClick = useCallback(() => {
    navigateToURL(chatSettingsModalUrl(ChatSettingsTab.AGENTS));
  }, []);

  return (
    <SidebarRow
      icon={<BenchlingIcon icon="plus" />}
      label="Set up an Agent"
      onClick={handleClick}
      hoverHighlight={true}
      dataTestAttrs={{component: 'SetUpAnAgentRow', element: 'root'}}
    />
  );
}
